import api from "..";
import API_ENDPOINTS from "../endpoints";

export const getTeamDetails = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.TEAM_DETAILS,
    params: {
      team_id: data.team_id,
    },
  });

  return response.data;
};

export const getTeamHighlights = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.TEAM_HIGHLIGHTS,
    params: {
      page: data?.page || 1,
      limit: data?.limit || 24,
      geo_lat: data?.geo_lat || 0,
      geo_long: data?.geo_long || 0,
      team_id: data.team_id,
    },
  });

  return response.data;
};

export const getTeamPosts = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.TEAM_POSTS,
    params: {
      page: data?.page || 1,
      limit: data?.limit || 24,
      geo_lat: data?.geo_lat || 0,
      geo_long: data?.geo_long || 0,
      team_id: data.team_id,
    },
  });

  return response.data;
};
